export default __webpack_public_path__ + "static/media/DALMA PREMIERE 5.67508bdc.jpg";